var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"count-item",on:{"click":function($event){return _vm.openPage(item)}}},[_c('div',[_c('span',[_vm._v(_vm._s(item.count))]),_c('p',[_vm._v(_vm._s(item.desc))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }